import { FC } from 'react';
import { getCssVarValue } from '@mybonum/ui';
import { Flex } from 'antd';

import { ActionsButton } from '../actions-button';

import { TPracticeType } from '@/modules/practices/types.ts';
import { ColumnsConfigurator } from '@/widgets/columns-configurator';
import { Search } from '@/widgets/search';

export const PracticesFilter: FC = () => {
    return (
        <Flex gap={getCssVarValue('spacing-sm', true)} justify="space-between">
            <Flex gap={getCssVarValue('spacing-sm', true)} style={{ flexGrow: 1 }}>
                <Search style={{ maxWidth: '450px' }} />
                <ColumnsConfigurator<TPracticeType> />
            </Flex>
            <ActionsButton />
        </Flex>
    );
};
